<div class="pad-10 overflow-a height-100" cdkScrollable (window:resize)="onResize()">
  <div class="desk-view">
    <div class="vesselcontainer height-100">
      <div class="bg-white border-r-4 pos-r border-c border pad-10 mar-b-30">
        <div class="pad-b-10">
          <ng-container *ngTemplateOutlet="searchPannel"></ng-container>
        </div>
        <div class="pos-a width-100" style="bottom:0px;left: 0px;" *ngIf="loading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div class="pos-a" style="left: calc(50% - 60px);bottom: -19px;">
          <button mat-flat-button color="primary" style="width: 160px;border-radius: 20px;height: 42px;"
            (click)="search()">Search Schedule</button>
        </div>
      </div>

      <div class="pad-lr-50 mar-tb-30 width-100">
        <!-- <app-vessel-schedule-timeline [VesselDataList]="VesselDataList"
                  [app]="'portal'"></app-vessel-schedule-timeline> -->
        <!-- <lib-timeline [VesselDataList]="VesselDataList" [app]="'portal'"></lib-timeline> -->
        <div class="vesselcontainer mar-b-10 f-w-500 font-16 flex align-c justify-space-between "
          *ngIf="!!VesselDataList.length">
          <div>Vessel Schedule</div>
          <ng-container *ngTemplateOutlet="sortCompt"></ng-container>
        </div>
        <app-vs-timeline [VesselDataList]="VesselDataList" [queryParamsData]="queryParamsData" [loading]="loading"
          [getObj]="searchObj" [app]="'portal'"></app-vs-timeline>
      </div>

    </div>
  </div>

  <div class="mb-view overflow-a height-100">
    <div class="pad-10 bg-white pos-r" style="padding-bottom: 35px;margin-bottom: 35px;">
      <div class="flex align-c mar-b-10-res">
        <div class="grid pos-r width-100" style="grid-template-columns: calc(50% - 2px) calc(50% - 2px);">
          <div class="pos-a swape-btn pointer" matRipple (click)="swape()">
            <mat-icon class="head-c">swap_horiz</mat-icon>
          </div>
          <ng-container *ngTemplateOutlet="fromTemplate"></ng-container>
          <ng-container *ngTemplateOutlet="toTemplate"></ng-container>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="schedule"></ng-container>

      <div class="pos-a width-100" style="bottom:0px;left: 0px;" *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <ng-container *ngTemplateOutlet="layerTwoFilter"></ng-container>
      <div class="pos-a" style="left: calc(50% - 76px);bottom: -19px;">
        <button mat-flat-button color="primary" style="width: 160px;border-radius: 20px;height: 42px;"
          (click)="search()">Search Schedule</button>
      </div>
    </div>

    <div class="pad-lr-50 mar-tb-30 width-100">
      <!-- <app-vessel-schedule-timeline [VesselDataList]="VesselDataList" [app]="'portal'"></app-vessel-schedule-timeline> -->
      <!-- <lib-timeline [VesselDataList]="VesselDataList" [app]="'portal'"></lib-timeline> -->
      <app-vs-timeline [VesselDataList]="VesselDataList" [queryParamsData]="queryParamsData" [loading]="loading"
        [getObj]="searchObj" [app]="'portal'"></app-vs-timeline>
    </div>
  </div>
</div>

<ng-template #searchPannel>
  <div class="">
    <div class="pad-10">
      <div class="flex align-c" style="width: max-content;">
      </div>
      <div class="grid align-c mar-t-20 g-t">
        <div class="flex align-c mar-b-10-res">
          <div class="grid pos-r width-100 grid-t-49-49 ">
            <div class="pos-a swape-btn pointer" matRipple (click)="swape()">
              <mat-icon class="head-c">swap_horiz</mat-icon>
            </div>
            <ng-container *ngTemplateOutlet="fromTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="toTemplate"></ng-container>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="schedule"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="layerTwoFilter"></ng-container>
    </div>

  </div>

</ng-template>

<ng-template #schedule>
  <div class="mar-l-5-res mar-b-10-res">
    <div class="input-c pad-10 mar-l-5-res grid  align-c width-100 {{!!validateError.filter_type ? 'red-border' : ''}}"
      style="grid-template-columns: 20px auto max-content;height: 50px;">
      <mat-icon class="over-i icon-20">schedule</mat-icon>
      <div *ngIf="!!queryParamsData?.filter_type" (click)="queryParamsData.filter_type = null" class="mar-l-10">
        {{searchObj.filter_type ? searchObj.filter_type : queryParamsData?.filter_type}}
      </div>
      <mat-select *ngIf="!queryParamsData?.filter_type" placeholder="Departing" class="pad-l-10"
        [(ngModel)]="searchObj.filter_type">
        <mat-option value="departure">Departure</mat-option>
        <mat-option value="arrival">Arrival</mat-option>
      </mat-select>
    </div>
  </div>

  <div class="width-100 flex">
    <div class="mar-l-5-res width-100">
      <div
        class="input-c pad-10 mar-l-5-res grid  align-c width-100 grid-date-tem {{!!validateError.from_date ? 'red-border' : ''}}">
        <span class="material-symbols-outlined pointer icon-20" (click)="fromDate.open()">calendar_month</span>
        <mat-datepicker #fromDate></mat-datepicker>
        <input [matDatepicker]="fromDate" class="width-200 font-14" (focus)="fromDate.open()" placeholder="From"
          [(ngModel)]="searchObj.from_date"
          (dateChange)="dateValidation.toMin=searchObj.from_date;searchObj.to_date=null;"
          [min]="dateValidation.fromMin">
      </div>
    </div>

    <div class="mar-l-5 width-100">
      <div
        class="input-c pad-10 mar-l-5 grid  align-c width-100 grid-date-tem {{!!validateError.to_date ? 'red-border' : ''}}">
        <span class="material-symbols-outlined pointer icon-20" (click)="toDate.open()">calendar_month</span>
        <mat-datepicker #toDate></mat-datepicker>
        <input [matDatepicker]="toDate" class="width-200 font-14" (focus)="toDate.open()" placeholder="To"
          [(ngModel)]="searchObj.to_date" [min]="!!dateValidation.fromMin?dateValidation.fromMin:dateValidation.toMin">
      </div>
    </div>

    <!-- <mat-datepicker-toggle matIconSuffix [for]="rangePicker" style="color: #0264ed;"></mat-datepicker-toggle> -->

    <!-- <div class="pos-a">
      <span class="material-symbols-outlined pointer icon-20 f-date">calendar_month</span>
    </div> -->

    <!-- <mat-date-range-input [rangePicker]="rangePicker" class="{{!!validateError.from_date ? 'bor' : ''}}">
      <input matStartDate placeholder="From" (focus)="rangePicker.open()" [(ngModel)]="searchObj.from_date">
      <input matEndDate placeholder="To" (focus)="rangePicker.open()" [(ngModel)]="searchObj.to_date">
    </mat-date-range-input> -->

    <!-- <div class="pos-a">
      <span class="material-symbols-outlined pointer icon-20 t-date">calendar_month</span>
    </div> -->
    <div class="line-input date-lv"></div>
    <!-- <mat-date-range-picker #rangePicker>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancel</button>
        <button mat-raised-button color="primary" matDateRangePickerApply (click)="search()">Apply</button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker> -->
  </div>
</ng-template>

<ng-template #toTemplate>
  <div>
    <div class="input-c pad-10 mar-l-5 grid  align-c width-100 {{!!validateError.to ? 'red-border' : ''}}"
      style="grid-template-columns: 30px auto max-content;height: 50px;">
      <div class="pad-lr-10 flex align-c justify-c">
        <span class="material-symbols-outlined "
          *ngIf="!searchObj.to || (!!searchObj.to && !searchObj.to.id)">distance</span>
        <span class="material-symbols-outlined " *ngIf="!!searchObj.to && !!searchObj.to.id">directions_boat</span>
      </div>
      <div *ngIf="!!searchObj.to && !searchObj.open_to" (click)="searchObj.open_to=true;searchObj.to = null"
        class="width-100 grid grid-gap-10 grid-t-s">
        <div class="overflow-e">{{searchObj.to?.location_name ? searchObj.to?.location_name :
          queryParamsData?.destination?.location_name}} <span *ngIf="!!searchObj.to?.location_code">({{searchObj.to?.location_code ?
            searchObj.to?.location_code : queryParamsData?.destination?.location_code}})</span> -
          {{searchObj.to?.country_code ? searchObj.to?.country_code :
          queryParamsData?.destination?.country_code}}</div>
        <div></div>
      </div>
      <input *ngIf="!searchObj.to || !!searchObj.open_to" type="search" class="pad-10" placeholder="Select Destination"
        [(ngModel)]="searchObj.to" #fromPortinputElement #fromAutoTrigger="matAutocompleteTrigger"
        (focus)="getPortSearch($event.target)" (input)="getPortSearch($event.target)" [matAutocomplete]="autoFromPort"
        (click)="selectInputValue(fromPortinputElement);searchObj.open_to = true"
        (selectionchange)="afterSelectLocation('to');">
      <mat-autocomplete #autoFromPort="matAutocomplete" [displayWith]="displayFnPortValue" autoActiveFirstOption
        [panelWidth]="autoCompletePannelWidth">
        @for (option of portList; track option) {
        <div
          class=" pos-r {{!!option?.nearby_ports ?'border-c border-t':''}} {{!!option?.nearby_ports && !option['open']?' border-b':''}}">
          <mat-option [value]="option" (optionSelected)="getObj.to=option;portList =[];">
            <app-port-opt [option]="option"></app-port-opt>
          </mat-option>
          <div class="flex align-c justify-r mar-l-10 bg-white pad-10 pos-a nb-ar" matRipple
            *ngIf="!!option?.nearby_ports && !!option?.nearby_ports.length" (click)="option['open']=!option['open']">
            <span class="material-symbols-outlined">{{option['open']?'keyboard_arrow_up':'keyboard_arrow_down'}}</span>
          </div>
          <div *ngIf="option?.nearby_ports && !!option['open']" class="border-c border-b ">
            <div *ngFor="let i of option?.nearby_ports">
              <mat-option [value]="i" class="align-c" (optionSelected)="getObj.to=i;portList =[];"
                style="grid-template-columns: 30px calc(100% - 30px);padding-left: 50px;">
                <app-port-opt [option]="i"></app-port-opt>
              </mat-option>

            </div>
          </div>
        </div>

        }
      </mat-autocomplete>

    </div>
  </div>
</ng-template>

<ng-template #fromTemplate>
  <div>
    <div class="input-c pad-10 grid align-c {{!!validateError.from ? 'red-border' : ''}}"
      style="grid-template-columns: 30px auto max-content;height: 50px;">
      <div class="pad-lr-10 flex align-c justify-c">
        <span class="material-symbols-outlined "
          *ngIf="!searchObj.from || (!!searchObj.from && !searchObj.from.id)">distance</span>
        <span class="material-symbols-outlined " *ngIf="!!searchObj.from && !!searchObj.from.id">directions_boat</span>
      </div>
      <div *ngIf="!!searchObj.from && !searchObj.open_from" (click)="searchObj.open_from=true;searchObj.from = null"
        class="width-100 grid grid-gap-10 grid-t-s">
        <div class="overflow-e">{{searchObj.from?.location_name ? searchObj.from?.location_name :
          queryParamsData?.origin?.location_name}} <span *ngIf="!!searchObj.from?.location_code">({{searchObj.from?.location_code ?
            searchObj.from?.location_code : queryParamsData?.origin?.location_code}})</span> -
          {{searchObj.from?.country_code ? searchObj.from?.country_code :
          queryParamsData?.origin?.country_code}}</div>
        <div></div>
      </div>
      <input *ngIf="!searchObj.from || !!searchObj.open_from" type="search" class="pad-10" placeholder="Select Origin"
        [(ngModel)]="searchObj.from" #fromPortinputElement #fromAutoTrigger="matAutocompleteTrigger"
        (selectionchange)="afterSelectLocation('from');" (focus)="getPortSearch($event.target)"
        (input)="getPortSearch($event.target)" [matAutocomplete]="autoFromPort"
        (click)="selectInputValue(fromPortinputElement);searchObj.open_from = true">
      <mat-autocomplete #autoFromPort="matAutocomplete" [displayWith]="displayFnPortValue" autoActiveFirstOption
        [panelWidth]="autoCompletePannelWidth">
        @for (option of portList; track option) {
        <div
          class=" pos-r {{!!option?.nearby_ports ?'border-c border-t':''}} {{!!option?.nearby_ports && !option['open']?' border-b':''}}">
          <mat-option [value]="option" (optionSelected)="getObj.from=option;portList =[];">
            <app-port-opt [option]="option"></app-port-opt>
          </mat-option>
          <div class="flex align-c justify-r mar-l-10 bg-white pad-10 pos-a nb-ar" matRipple
            *ngIf="!!option?.nearby_ports && !!option?.nearby_ports.length" (click)="option['open']=!option['open']">
            <span class="material-symbols-outlined">{{option['open']?'keyboard_arrow_up':'keyboard_arrow_down'}}</span>
          </div>
          <div *ngIf="option?.nearby_ports && !!option['open']" class="border-c border-b ">
            <div *ngFor="let i of option?.nearby_ports">
              <mat-option [value]="i" class="align-c" (optionSelected)="getObj.from=i;portList =[];"
                style="grid-template-columns: 30px calc(100% - 30px);padding-left: 50px;">
                <app-port-opt [option]="i"></app-port-opt>
              </mat-option>

            </div>
          </div>
        </div>

        }
      </mat-autocomplete>
    </div>
  </div>
</ng-template>

<ng-template #editPenIcon>
  <svg _ngcontent-fcu-c465="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16"
    height="16" viewBox="0 0 20 20" class="EditIcon--27e1eed3 ng-star-inserted">
    <defs _ngcontent-fcu-c465="">
      <path _ngcontent-fcu-c465="" id="EditIcon_svg__a" d="M0 0h20v20H0z"></path>
    </defs>
    <g _ngcontent-fcu-c465="" fill="none" fill-rule="evenodd">
      <mask _ngcontent-fcu-c465="" id="EditIcon_svg__b" fill="#fff">
        <use _ngcontent-fcu-c465="" xlink:href="#EditIcon_svg__a"></use>
      </mask>
      <path _ngcontent-fcu-c465="" fill="#61656C" fill-rule="nonzero"
        d="M12.696 2.639a2.182 2.182 0 012.966-.111l.12.11 1.58 1.58c.812.814.85 2.11.11 2.966l-.11.12-9.757 9.755a.727.727 0 01-.306.183l-.088.02-4.364.728a.727.727 0 01-.846-.746l.01-.091.726-4.364c.02-.12.07-.232.144-.327l.06-.067 9.755-9.756zm-1.002 3.06l-7.56 7.558-.522 3.13 3.13-.522 7.559-7.56-2.607-2.607zm2.977-2.102a.728.728 0 00-.865 0l-.081.07-1.003 1.003 2.607 2.607 1.004-1.002a.728.728 0 00.126-.858l-.056-.088-.07-.082-1.58-1.58-.082-.07z"
        mask="url(#EditIcon_svg__b)"></path>
    </g>
  </svg>
</ng-template>


<ng-template #layerTwoFilter>
  <div class="flex align-c overflow-a mar-t-15 justify-space-between">
    <div class="flex align-c">
      <div class="flex align-c justify-space-between primary-c f-w-500">
        <div class="mar-r-5 wid-m font-12">Filter by : &nbsp;</div>
      </div>
      <div class="flex align-c">
        <div class="flex align-c justify-space-between s-btn pointer {{searchObj.liners.length?'s-btn-act-filter':''}}"
          matRipple [matMenuTriggerFor]="linerMenu">
          <div class="flex align-c" *ngIf="!searchObj.liners?.length"><span class="wid-m mar-r-5">Shipping liners</span>
            <span class="material-symbols-outlined">arrow_drop_down</span></div>
          <div class="flex align-c" *ngIf="!!searchObj.liners?.length" matTooltip="Shipping liners">
            <div class="f-w-500 font-12 overflow-e " style="max-width: 100px;"> <span
                *ngFor="let opt of searchObj.liners;index as indexAs">
                {{opt?.scac_code}}
                {{((indexAs==0 && searchObj.liners?.length>1)|| indexAs!=0) && indexAs!=searchObj.liners?.length-1?',':''}}
              </span>
            </div>
            <span *ngIf="searchObj.liners?.length>2">+{{searchObj.liners?.length-2}}</span>
            <span class="material-symbols-outlined head-c pointer mar-l-5 icon-20"
              (click)="clearFilter('liner')">close</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<mat-menu #linerMenu="matMenu" [class]="'filter-panel'">
  <div class="flex align-c justify-space-between mar-r-10 width-100 border-b border-c" id="liner-filter-menu">
    <div class="pad-10 f-w-500 font-14">Liners List</div>
    <button class="icon-btn-basic">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="overflow-a pad-10" id="filter-menu-container" style="max-height: 400px;"
    (click)="$event.stopPropagation()">
    <div *ngFor="let item of optionList.linerList" class="pad-tb-5 overflow-e">
      <mat-checkbox class="font-14" [(ngModel)]="item.checked" color="primary"
        (change)="selectedLiner(optionList.linerList)">
        <div class="overflow font-14">{{item?.liner_name}}</div>
        <div class="sub-c font-10">{{item?.scac_code}}</div>
      </mat-checkbox>
    </div>
  </div>
  <div class="pad-10 flex align-c justify-r border-t border-c">
    <button mat-stroked-button (click)="clearFilter('liner')">Clear</button>
  </div>
</mat-menu>


<ng-template #sortCompt>
  <div class="flex align-c">
    <button [matMenuTriggerFor]="menu" class="m-btn pointer border-r-4 primary-c" matRipple>
      Sort by :
      <span class="material-symbols-outlined icon-20 mar-l-5">swap_vert</span>
    </button>
    <mat-menu #menu="matMenu">
      @for (sort of sortList; track sort) {
      <div class="flex algin-c justify-space-between pad-10 pointer {{getObj.sort_by==sort.name?'primary-c':''}}"
        matRipple (click)="getObj.sort_by=sort.name;search();">
        <span>{{sort.dname}}</span>
        <mat-icon class="icon-20 mar-l-10" *ngIf="getObj.sort_by==sort.name">checked</mat-icon>
      </div>
      }
    </mat-menu>
  </div>
</ng-template>
